"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _gmap_utils = _interopRequireDefault(require("../../../lib/gmap_utils"));
var _apiListingsSearch = _interopRequireDefault(require("../../../api/api-listings-search"));
var _apiEnv = _interopRequireDefault(require("../../../api/api-env"));
var _searchMetroDropdown = require("./search-metro-dropdown");
var _locationModal = require("./location-modal");
var _activityModal = require("./activity-modal");
var _errorDropdown = require("./error-dropdown");
var _activityDropdown = require("./activity-dropdown");
var _emailDropdown = require("./email-dropdown");
var _sharedIntlProviderHOC = _interopRequireDefault(require("../shared-components/hocs/sharedIntlProviderHOC"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var SearchForm = exports.SearchForm = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchForm, _React$Component);
  function SearchForm(props) {
    var _this;
    _classCallCheck(this, SearchForm);
    _this = _callSuper(this, SearchForm, [props]);
    _this.state = {
      country: 'us',
      metros: [],
      defaults: [],
      locationFocus: false,
      enableLClickOutside: false,
      activityFocus: false,
      enableAClickOutside: false,
      activityLoading: true,
      activityValue: '',
      locationValue: '',
      clearedActivity: false
    };
    _this.handleSearchButtonClick = _this.handleSearchButtonClick.bind(_assertThisInitialized(_this));
    _this.locationKeydown = _this.locationKeydown.bind(_assertThisInitialized(_this));
    _this.activityKeydown = _this.activityKeydown.bind(_assertThisInitialized(_this));
    _this.locationOnChange = _this.locationOnChange.bind(_assertThisInitialized(_this));
    _this.activityOnChange = _this.activityOnChange.bind(_assertThisInitialized(_this));
    _this.onFocusLocation = _this.onFocusLocation.bind(_assertThisInitialized(_this));
    _this.onFocusActivity = _this.onFocusActivity.bind(_assertThisInitialized(_this));
    _this.onBlurLocation = _this.onBlurLocation.bind(_assertThisInitialized(_this));
    _this.onBlurActivity = _this.onBlurActivity.bind(_assertThisInitialized(_this));
    _this.handleLocationClick = _this.handleLocationClick.bind(_assertThisInitialized(_this));
    _this.handleActivityClick = _this.handleActivityClick.bind(_assertThisInitialized(_this));
    _this.modalActivityClick = _this.modalActivityClick.bind(_assertThisInitialized(_this));
    _this.showEmailDropdown = _this.showEmailDropdown.bind(_assertThisInitialized(_this));
    _this.openLocationDropDown = _this.openLocationDropDown.bind(_assertThisInitialized(_this));
    _this.openActivityDropDown = _this.openActivityDropDown.bind(_assertThisInitialized(_this));
    _this.openLocationModal = _this.openLocationModal.bind(_assertThisInitialized(_this));
    _this.openActivityModal = _this.openActivityModal.bind(_assertThisInitialized(_this));
    _this.closeLocationDropDown = _this.closeLocationDropDown.bind(_assertThisInitialized(_this));
    _this.closeActivityDropDown = _this.closeActivityDropDown.bind(_assertThisInitialized(_this));
    _this.recordUseClick = _this.recordUseClick.bind(_assertThisInitialized(_this));
    _this.renderSearchButton = _this.renderSearchButton.bind(_assertThisInitialized(_this));
    _this.handleUseTypeListClick = _this.handleUseTypeListClick.bind(_assertThisInitialized(_this));
    _this.autoComplete = _this.autoComplete.bind(_assertThisInitialized(_this));
    _this.getActivityDropOptions = _this.getActivityDropOptions.bind(_assertThisInitialized(_this));
    _this.onClickLocation = _this.onClickLocation.bind(_assertThisInitialized(_this));
    _this.onClickActivity = _this.onClickActivity.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(SearchForm, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;
      var date = Date.now();
      _apiEnv.default.getMetros(date, function (metros) {
        _this2.setState({
          metros: metros
        });
      });
      if ('modal' === this.props.origin || 'landing' === this.props.origin) {
        this.setState({
          nickname: this.props.nickname || '',
          locationValue: this.props.location || '',
          activityValue: this.props.activityValue || '',
          activityID: this.props.activityID || ''
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      var locationInput = this.refs.locationInput;
      var activityInput = this.refs.activityInput;
      if ($(locationInput).is(':focus')) {
        this.onFocusLocation();
      }
      if ('modal' === this.props.origin || 'landing' === this.props.origin) {
        this.refs.locationInput.value = this.props.location || '';
      }
      var locale = _sharedIntlProviderHOC.default.getLocale();
      _apiEnv.default.getActivities(locale, function (response) {
        var activities = response.response;
        var defaultDropdowns = ['Meeting', 'Film Shoot', 'Party', 'Photo Shoot', 'Workshop'];
        var subtypes = _.filter(activities, function (a) {
          return -1 !== defaultDropdowns.indexOf(a.dropdown);
        });
        var _window = window,
          Sifter = _window.Sifter;
        _this3.setState({
          sifter: new Sifter(activities),
          defaults: subtypes,
          activities: activities
        }, function () {
          _this3.setState({
            activityLoading: false
          }, function () {
            if ($(activityInput).is(':focus')) {
              _this3.onFocusActivity(true);
            }
          });
        });
      });
    }

    // NOTE: not necesary for landing pages
    // componentWillReceiveProps (nextProps) {
    //   const selectedFilters = nextProps.selectedFilters;
    //   const activityValue = selectedFilters ? selectedFilters.useTypeObj : '';
    //   const locationValue = selectedFilters ? selectedFilters.locationObj : '';
    //
    //   /* setting search keyword cookie when user lands on this page directly */
    //   if (PSSessions) {
    //     PSSessions.set.thisCookie('PSSK', activityValue, Date.now() + 3888000000);
    //   }

    //   this.setState({
    //     activityValue,
    //     locationValue
    //   });
    // }
  }, {
    key: "onBlurActivity",
    value: function onBlurActivity(e) {
      e.stopPropagation();
      this.setState({
        activityFocus: false,
        activityPlaceholder: 'What are you planning?'
      });
    }
  }, {
    key: "onBlurLocation",
    value: function onBlurLocation(e) {
      e.stopPropagation();
      this.setState({
        locationFocus: false,
        locationPlaceholder: this.props.locationPlaceholder
      });
    }
  }, {
    key: "onFocusActivity",
    value: function onFocusActivity() {
      this.setState({
        activityFocus: true,
        activityPlaceholder: 'Enter your activity'
      });
      this.openActivityDropDown();
    }
  }, {
    key: "onClickActivity",
    value: function onClickActivity(e) {
      if (e) {
        var inputValue = this.refs.activityInput.value;
        if (!this.state.activityDropdown && inputValue) {
          this.setState({
            activityValue: inputValue,
            activitySuggestions: this.getActivityDropOptions(inputValue)
          });
        }
        if (e.target) {
          e.target.select();
        }
      }
    }
  }, {
    key: "onFocusLocation",
    value: function onFocusLocation() {
      this.setState({
        locationFocus: true,
        locationPlaceholder: 'Enter a city or address'
      });
      return this.openLocationDropDown();
    }
  }, {
    key: "onClickLocation",
    value: function onClickLocation(e) {
      if (e) {
        e.currentTarget.select();
        var nickname = $(e.currentTarget).attr('data-nickname');
        if (e.currentTarget.value && !nickname) {
          var inputValue = e.currentTarget.value;
          if (!this.state.locDropdown) {
            return this.autoComplete(inputValue, this.openLocationDropDown);
          }
        }
      }
    }
  }, {
    key: "getActivityDropOptions",
    value: function getActivityDropOptions(input) {
      var _this4 = this;
      if (!this.state.activityLoading) {
        var droptions = [];
        this.state.sifter.search(input, {
          fields: ['dropdown', 'use-subtype', 'display_use_type'],
          limit: 5
        }).items.forEach(function (element) {
          droptions.push(_this4.state.activities[element.id]);
        });
        return droptions;
      }
    }
  }, {
    key: "openActivityDropDown",
    value: function openActivityDropDown() {
      this.setState({
        activityMenu: 'open',
        enableAClickOutside: true,
        locationMenu: '',
        enableLClickOutside: false
      });
      analyticsIntegrations.searchDropdown(this.props.origin, 'activity');
    }
  }, {
    key: "openLocationDropDown",
    value: function openLocationDropDown() {
      this.setState({
        locationMenu: 'open',
        enableLClickOutside: true,
        activityMenu: '',
        enableAClickOutside: false
      });
      analyticsIntegrations.searchDropdown(this.props.origin, 'location');
    }
  }, {
    key: "closeActivityDropDown",
    value: function closeActivityDropDown() {
      this.setState({
        activityMenu: '',
        enableAClickOutside: false
      });
    }
  }, {
    key: "closeLocationDropDown",
    value: function closeLocationDropDown() {
      this.setState({
        locationMenu: '',
        enableLClickOutside: false
      });
    }
  }, {
    key: "recordUseClick",
    value: function recordUseClick() {
      analyticsIntegrations.searchDropdown(this.props.origin, 'activity');
    }
  }, {
    key: "handleUseTypeListClick",
    value: function handleUseTypeListClick(value) {
      this.setState({
        selectedUseType: value
      });
    }
  }, {
    key: "showMissingSelectOptions",
    value: function showMissingSelectOptions(targetClassOrID) {
      return $(targetClassOrID).dropdown('toggle');
    }
  }, {
    key: "handleActivityClick",
    value: function handleActivityClick(e, f, modal) {
      var _this5 = this;
      e.stopPropagation();
      e.preventDefault();
      var targetElement = e.currentTarget;
      var typedActivityValue = this.refs.activityInput.value;
      var skt = modal ? 'modal' : typedActivityValue ? 'input' : 'default';
      var activityValue = targetElement.getAttribute('data-name');
      var activityID = targetElement.getAttribute('data-id');
      this.refs.activityInput.value = activityValue;
      this.refs.activityInput.setAttribute('data-id', activityID);
      this.closeActivityDropDown();
      PSSessions.Cookies.set('PSSK', activityValue, Date.now() + 3888000000);
      PSSessions.Cookies.set('PSSKT', skt, Date.now() + 3888000000);
      this.setState({
        activityDropdown: '',
        activityValue: activityValue,
        activityID: activityID
      }, function () {
        if ('search' === _this5.props.origin) {
          _this5.handleSearchButtonClick(false, false, true);
        }
      });
    }
  }, {
    key: "modalActivityClick",
    value: function modalActivityClick(e) {
      this.handleActivityClick(e, null, true);
    }
  }, {
    key: "handleLocationClick",
    value: function handleLocationClick(e) {
      var _this6 = this;
      e.stopPropagation();
      e.preventDefault();
      var targetElement = e.currentTarget;
      var activeMetro = $(targetElement).attr('data-active');
      if ('false' === activeMetro) {
        var landingPageUrl = $(this).attr('data-landing');
        if (landingPageUrl) {
          window.open(landingPageUrl, '_blank');
        }
        return;
      }
      var locationValue = targetElement.getAttribute('data-name');
      var locationInput = this.refs.locationInput || document.getElementById('searchbar-input');
      locationInput.value = locationValue;
      this.closeLocationDropDown();
      this.setState({
        locDropdown: '',
        locationValue: locationValue,
        nickname: targetElement.getAttribute('data-value'),
        placeId: targetElement.getAttribute('data-placeid')
      }, function () {
        if ('search' === _this6.props.origin) {
          _this6.handleSearchButtonClick(false, false, false);
        }
      });
    }
  }, {
    key: "handleSearchButtonClick",
    value: function handleSearchButtonClick(e, f, activityOnly) {
      var _this7 = this;
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      var spaceTypePage = document.getElementById('landing-page-components');
      var origin = this.props.origin;
      var metroInput = $(this.refs.locationInput);
      var useTypeDropdown = this.refs.activityInput;
      var metroInputIsMetro = !!metroInput.attr('data-nickname');
      var usetypeValue = useTypeDropdown ? useTypeDropdown.getAttribute('data-id') : this.props.activityID;
      var geo = _gmap_utils.default.geoCoder();
      var queryObj = {};
      if (usetypeValue) {
        queryObj.a = usetypeValue;
      }
      if (!usetypeValue && e) {
        this.openActivityDropDown();
      } else if (!metroInput[0].value && e) {
        this.openLocationDropDown();
      } else {
        if (activityOnly) {
          return this.props.filterResults(queryObj);
        }
        if (metroInputIsMetro) {
          var loccodeValue = metroInput.val();
          var createSearchLoc = loccodeValue.toLowerCase().replace(/\,\s/g, '--').replace(/ /g, '-');
          var p1String = "".concat(createSearchLoc, "/?a=").concat(usetypeValue);
          if ('search' === origin) {
            return this.props.filterResults({
              loc_code: createSearchLoc
            });
          }
          location.href = "/s/".concat(p1String).concat(spaceTypePage ? '&gs=1' : '');
        } else {
          var doautocomplete = function doautocomplete(placeId) {
            geo.geocode({
              placeId: placeId
            }, function (results) {
              if (0 === results.length) {
                var metroValue = metroInput.val();
                _this7.locationOnChange(null, metroValue);
                return _this7.openLocationDropDown();
              }
              queryObj.location = metroInput.val().replace(/\,\s/g, '--').replace(/\s/g, '-');
              var geom = results[0].geometry;
              var POITypes = ['ROOFTOP', 'RANGE_INTERPOLATED'];
              if (-1 !== POITypes.indexOf(geom.location_type)) {
                var lat = geom.location.lat();
                var lng = geom.location.lng();
                queryObj.point_of_interest = "[".concat([lat, lng], "]");
              } else {
                if (geom.viewport) {
                  queryObj.bbox_of_interest = _gmap_utils.default.boundsToSearchArray(geom.viewport);
                } else {
                  return _this7.showEmailDropdown(results, queryObj);
                }
              }
              _apiListingsSearch.default.get(queryObj, _this7.state.activities, function (listings, response) {
                if (!listings.length) {
                  _this7.showEmailDropdown(results, queryObj);
                } else {
                  queryObj.viewport_bbox = "[".concat([response.suggested_viewport_bbox], "]");
                  if ('search' === origin) {
                    _this7.props.filterResults(queryObj, false, !activityOnly);
                  } else {
                    var _this7$props = _this7.props,
                      filterType = _this7$props.filterType,
                      filterText = _this7$props.filterText;
                    if (filterText && filterType) {
                      queryObj[filterType] = encodeURIComponent(filterText);
                    }
                    var queryString = function (qObj) {
                      var qString = _.reduce(qObj, function (str, val, key) {
                        if (!val) {
                          return str;
                        } else if (0 >= str.length) {
                          return key + '=' + val;
                        }
                        return str + '&' + key + '=' + val;
                      }, '');
                      return qString;
                    }(queryObj);
                    var hasAtLeast100Listings = 100 <= listings.length;
                    location.href = "/s/?".concat(queryString).concat(hasAtLeast100Listings && spaceTypePage ? '&gs=1' : '').toLowerCase();
                  }
                }
              });
            });
          };
          var placeId = metroInput.attr('data-placeid');
          if (placeId) {
            doautocomplete(placeId);
          } else {
            var autoComplete = _gmap_utils.default.autoCompleteService();
            var options = {
              input: metroInput[0].value,
              types: ['geocode']
            };
            autoComplete.getPlacePredictions(options, function (predictions, status) {
              if ('OK' === status) {
                placeId = predictions[0].place_id;
                doautocomplete(placeId);
              } else {
                _this7.openLocationDropDown();
              }
            });
          }
        }
      }
    }
  }, {
    key: "showEmailDropdown",
    value: function showEmailDropdown(results, queryObj) {
      var _this8 = this;
      this.setState({
        locDropdown: 'email'
      }, function () {
        if ('modal' === _this8.props.origin) {
          _this8.showMissingSelectOptions('.js-searchbar-select-metro-modal');
        } else {
          _this8.showMissingSelectOptions('.js-searchbar-select-metro');
        }
      });
      analyticsIntegrations.searchEmail(results, queryObj, this.props.origin);
    }
  }, {
    key: "activityOnChange",
    value: function activityOnChange(e) {
      var _this9 = this;
      var inputValue = e ? e.currentTarget.value : '';
      this.setState({
        activityValue: inputValue,
        clearedActivity: false
      }, function () {
        if (inputValue) {
          _this9.setState({
            activitySuggestions: _this9.getActivityDropOptions(inputValue)
          });
        } else {
          _this9.setState({
            activitySuggestions: undefined,
            activityDropdown: '',
            clearedActivity: true
          });
        }
      });
    }
  }, {
    key: "locationOnChange",
    value: function locationOnChange(e, metroValue) {
      var inputValue = e ? e.currentTarget.value : metroValue;
      this.setState({
        locationValue: inputValue
      });
      if (inputValue) {
        this.autoComplete(inputValue);
      } else {
        $(e.currentTarget).attr('data-placeid', '');
        this.setState({
          locSuggestions: undefined,
          locDropdown: ''
        });
      }
    }
  }, {
    key: "autoComplete",
    value: function autoComplete(input, callback) {
      var _this10 = this;
      var autoComplete = _gmap_utils.default.autoCompleteService();
      var currentBounds = this.props.currentBounds;
      var bounds;
      if (currentBounds) {
        bounds = _gmap_utils.default.getBoundsFromSearchArr(currentBounds);
      }
      var options = {
        input: input,
        bounds: bounds,
        types: ['geocode']
      };
      autoComplete.getPlacePredictions(options, function (predictions, status) {
        if ('OK' === status) {
          _this10.setState({
            locSuggestions: predictions,
            locDropdown: ''
          }, function () {
            if (callback) {
              callback();
            }
          });
        } else {
          _this10.setState({
            locDropdown: 'error'
          });
          analyticsIntegrations.searchError(input, _this10.props.origin, 'location');
        }
      });
    }
  }, {
    key: "activityKeydown",
    value: function activityKeydown(e) {
      if (40 === e.keyCode) {
        e.preventDefault();
        $('#act-list-0 a').focus();
      } else if (13 === e.keyCode) {
        if (this.state.activitySuggestions) {
          $('#act-list-0').trigger('click');
          $(e.currentTarget).trigger('blur');
        }
      }
    }
  }, {
    key: "locationKeydown",
    value: function locationKeydown(e) {
      if (40 === e.keyCode) {
        e.preventDefault();
        $('#metro-list-0 a').focus();
      } else if (13 === e.keyCode) {
        if (this.state.locSuggestions) {
          $('#metro-list-0').trigger('click');
          $(e.currentTarget).trigger('blur');
        }
      }
    }
  }, {
    key: "openLocationModal",
    value: function openLocationModal(e) {
      e.preventDefault();
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_locationModal.LocationModal, {
        metros: this.state.metros,
        handleLocationClick: this.handleLocationClick,
        closeDropdown: this.closeLocationDropDown,
        origin: this.props.origin,
        acitvityValue: this.state.activityValue,
        acitvityID: this.state.activityID
      }), document.getElementById('modal-container'));
    }
  }, {
    key: "openActivityModal",
    value: function openActivityModal(e) {
      e.preventDefault();
      var activities = this.state.activities;
      var useTypes = _.filter(activities, function (a) {
        return a.use_subtype === a.dropdown;
      });
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_activityModal.ActivityModal, {
        activities: useTypes,
        handleActivityClick: this.modalActivityClick,
        closeDropdown: this.closeActivityDropDown,
        origin: this.props.origin,
        location: this.state.locationValue
      }), document.getElementById('modal-container'));
    }
  }, {
    key: "renderActivityDropOptions",
    value: function renderActivityDropOptions() {
      var _this$state = this.state,
        activityValue = _this$state.activityValue,
        activitySuggestions = _this$state.activitySuggestions,
        activityLoading = _this$state.activityLoading;
      if (activityLoading) {
        return null;
      }
      if (activityValue && activitySuggestions && !activitySuggestions.length) {
        analyticsIntegrations.searchError(activityValue, this.props.origin, 'use type');
        return /*#__PURE__*/_react.default.createElement(_errorDropdown.ErrorDropdown, {
          content: /*#__PURE__*/_react.default.createElement("span", null, "We don't recognize that activity. Try describing it differently or ", /*#__PURE__*/_react.default.createElement("span", {
            className: "link-span inline",
            onClick: this.openActivityModal
          }, "pick from popular activities.")),
          enableClickOutside: this.state.enableAClickOutside,
          closeDropdown: this.closeActivityDropDown,
          origin: this.props.origin
        });
      }
      return /*#__PURE__*/_react.default.createElement(_activityDropdown.ActivityDropdown, {
        defaults: this.state.defaults,
        suggestions: this.state.activitySuggestions,
        clickFn: this.handleActivityClick,
        seeMoreAction: this.openActivityModal,
        activityValue: this.state.activityValue,
        enableClickOutside: this.state.enableAClickOutside,
        closeDropdown: this.closeActivityDropDown,
        origin: this.props.origin
      });
    }
  }, {
    key: "renderLocDropOptions",
    value: function renderLocDropOptions() {
      var locDropdown = this.state.locDropdown;
      if ('error' === locDropdown) {
        return /*#__PURE__*/_react.default.createElement(_errorDropdown.ErrorDropdown, {
          content: /*#__PURE__*/_react.default.createElement("span", null, "We don't recognize that location"),
          enableClickOutside: this.state.enableLClickOutside,
          origin: this.props.origin,
          closeDropdown: this.closeLocationDropDown
        });
      } else if ('email' === locDropdown) {
        return /*#__PURE__*/_react.default.createElement(_emailDropdown.EmailDropdown, {
          clickFn: this.handleLocationClick,
          metros: this.state.metros,
          enableClickOutside: this.state.enableLClickOutside,
          closeDropdown: this.closeLocationDropDown,
          origin: this.props.origin
        });
      }
      return /*#__PURE__*/_react.default.createElement(_searchMetroDropdown.SearchMetroDropdown, {
        metros: this.state.metros,
        suggestions: this.state.locSuggestions,
        clickFn: this.handleLocationClick,
        locationValue: this.state.locationValue,
        enableClickOutside: this.state.enableLClickOutside,
        closeDropdown: this.closeLocationDropDown,
        origin: this.props.origin,
        all: this.props.allUSMetros,
        activityValue: this.state.activityValue,
        activityID: this.state.activityID
      });
    }
  }, {
    key: "renderSearchButton",
    value: function renderSearchButton() {
      var buttonCol = this.props.buttonCol;
      var optionalButtonClass = this.props.optionalButtonClass;
      if ('search' !== this.props.origin) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(buttonCol || 'col-sm-2', " search-group text-left")
        }, /*#__PURE__*/_react.default.createElement("button", {
          id: "searchbar-submit-button",
          className: "btn btn-primary btn-lg hero ".concat(optionalButtonClass),
          onClick: this.handleSearchButtonClick
        }, this.props.searchButtonText));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var locBlurred = this.state.locationFocus ? '' : 'blurred';
      var actBlurred = this.state.activityFocus ? '' : 'blurred';
      var _this$props = this.props,
        searchCol = _this$props.searchCol,
        containerFluid = _this$props.containerFluid,
        activity = _this$props.activity;
      var _this$state2 = this.state,
        sifter = _this$state2.sifter,
        activities = _this$state2.activities,
        activityID = _this$state2.activityID,
        activityLoading = _this$state2.activityLoading,
        activityValue = _this$state2.activityValue,
        activityPlaceholder = _this$state2.activityPlaceholder,
        clearedActivity = _this$state2.clearedActivity;
      var locationClass = '';
      if ('modal' === this.props.origin) {
        locationClass = 'js-searchbar-select-metro-modal';
      }
      var preFill = '';
      var preFillID = '';
      if (activity && !activityLoading) {
        var preFillMatch;
        if (sifter) {
          preFillMatch = sifter.search(activity, {
            fields: ['dropdown'],
            limit: 1
          }).items || [];
        } else {
          return null;
        }
        if (!_.isEmpty(preFillMatch)) {
          var actID = preFillMatch[0].id;
          var activityObj = activities[actID] || {};
          preFill = activity;
          preFillID = activityObj.id;
        }
      }
      var definedActivityValue = clearedActivity && !activityValue ? '' : activityValue || preFill;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerFluid || 'container'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-form row",
        role: "listbox"
      }, !this.props.showLocationOnly ? /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(searchCol || 'col-sm-4 col-sm-offset-1', " search-group use-type-input dropdown ").concat(this.state.activityMenu || '')
      }, /*#__PURE__*/_react.default.createElement("input", {
        "aria-haspopup": "true",
        "aria-expanded": "false",
        id: "activity-input",
        type: "text",
        className: "form-control ignore-clickoutside ".concat(actBlurred),
        onFocus: this.onFocusActivity,
        onBlur: this.onBlurActivity,
        onChange: this.activityOnChange,
        onClick: this.onClickActivity,
        onKeyDown: this.activityKeydown,
        placeholder: activityPlaceholder || 'What are you planning?',
        value: definedActivityValue,
        defaultValue: activityLoading ? '' : preFill,
        tabIndex: "0",
        ref: "activityInput",
        "data-id": activityID || (activityLoading ? '' : preFillID),
        autoComplete: "off"
      }), this.renderActivityDropOptions()) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(searchCol || 'col-sm-4', " search-group metro-input dropdown ").concat(this.state.locationMenu || '')
      }, /*#__PURE__*/_react.default.createElement("input", {
        "aria-haspopup": "true",
        "aria-expanded": "false",
        id: "searchbar-input",
        type: "text",
        "data-nickname": this.state.nickname,
        "data-placeid": this.state.placeId,
        className: "form-control ".concat(locationClass || 'js-searchbar-select-metro', " ignore-clickoutside ").concat(locBlurred),
        onFocus: this.onFocusLocation,
        onBlur: this.onBlurLocation,
        onChange: this.locationOnChange,
        onClick: this.onClickLocation,
        onKeyDown: this.locationKeydown,
        placeholder: this.state.locationPlaceholder || this.props.locationPlaceholder,
        value: this.state.locationValue,
        defaultValue: this.props.locationValue,
        tabIndex: "0",
        ref: "locationInput",
        autoComplete: "off"
      }), this.renderLocDropOptions()), this.props.buttonNewLine ? null : this.renderSearchButton()), this.props.buttonNewLine && /*#__PURE__*/_react.default.createElement("div", {
        className: "row",
        style: {
          marginTop: '8px'
        }
      }, this.renderSearchButton()));
    }
  }]);
  return SearchForm;
}(_react.default.Component);
SearchForm.propTypes = {
  origin: _propTypes.default.string,
  activity: _propTypes.default.string,
  activityID: _propTypes.default.string,
  activityValue: _propTypes.default.string,
  showLocationOnly: _propTypes.default.bool,
  searchButtonText: _propTypes.default.string,
  locationPlaceholder: _propTypes.default.string,
  allUSMetros: _propTypes.default.bool,
  nickname: _propTypes.default.string,
  location: _propTypes.default.string,
  filterResults: _propTypes.default.func,
  filterType: _propTypes.default.oneOf(['features', 'space_type']),
  filterText: _propTypes.default.string,
  buttonCol: _propTypes.default.string,
  searchCol: _propTypes.default.string,
  containerFluid: _propTypes.default.string,
  currentBounds: _propTypes.default.string
};
SearchForm.defaultProps = {
  searchButtonText: 'Search',
  locationPlaceholder: 'Where?'
};